import React from "react";
import { useLanguage } from "../context/LanguageContext";


const t = {
  sq: {
    title: "Shërbimet Tona Të Riparimit",
    sub: "Zgjidhje profesionale për riparimin e telefonave, tabletëve, laptopëve dhe pajisjeve të tjera.",

    servicesTitle: "Shërbimet",
    ctaTitle: "Ke nevojë për një riparim?",
    ctaSub:
      "Na shkruaj në WhatsApp dhe teknikët tanë do të të ndihmojnë menjëherë me diagnostikimin, çmimin dhe kohën e riparimit.",
    contact: "Kontakto në WhatsApp",
  },

  en: {
    title: "Our Repair Services",
    sub: "Professional repair solutions for phones, tablets, laptops and other devices.",

    servicesTitle: "Services",
    ctaTitle: "Need a repair?",
    ctaSub:
      "Contact us on WhatsApp and our technicians will assist you with diagnosis, pricing and repair time.",
    contact: "Contact on WhatsApp",
  },
};


const services = [
  {
    id: 1,
    title: { sq: "Ndërrim Ekrani", en: "Screen Replacement" },
    description: {
      sq: "Zëvendësim profesional i ekranit për të gjitha modelet e telefonave.",
      en: "Professional screen replacement for all phone models.",
    },
    icon: "📱",
  },
  {
    id: 2,
    title: { sq: "Riparim Bordi", en: "Board Repair" },
    description: {
      sq: "Riparim i pllakës amë për probleme të rënda teknike.",
      en: "Motherboard repair for complex hardware issues.",
    },
    icon: "🔩",
  },
  {
    id: 3,
    title: { sq: "Riparim Sensorësh", en: "Sensor Repair" },
    description: {
      sq: "Rregullim i sensorëve të telefonit me precizion të lartë.",
      en: "Fixing phone sensors with high precision.",
    },
    icon: "📊",
  },
  {
    id: 4,
    title: { sq: "Data Recovery", en: "Data Recovery" },
    description: {
      sq: "Rikuperim i të dhënave nga pajisje të dëmtuara.",
      en: "Recover lost data from damaged devices.",
    },
    icon: "💾",
  },
  {
    id: 5,
    title: { sq: "Riparim Xhamash", en: "Glass Repair" },
    description: {
      sq: "Ndërrim xhami pa ndërruar ekranin komplet.",
      en: "Glass replacement without full screen change.",
    },
    icon: "⚙️",
  },
  {
    id: 6,
    title: { sq: "Diagnostikim", en: "Diagnosis" },
    description: {
      sq: "Kontroll i plotë profesional i pajisjes.",
      en: "Full professional device diagnosis.",
    },
    icon: "🔧",
  },
  {
    id: 7,
    title: { sq: "Instalim Software", en: "Software Install" },
    description: {
      sq: "Instalim dhe përditësim sistemesh.",
      en: "System installation and updates.",
    },
    icon: "💿",
  },
  {
    id: 8,
    title: { sq: "Pastrimi Pajisjes", en: "Device Cleaning" },
    description: {
      sq: "Pastrim i brendshëm për performancë më të mirë.",
      en: "Internal cleaning for better performance.",
    },
    icon: "🧼",
  },
];

const Repair = () => {
  const { lang } = useLanguage();
  const text = t[lang] || t.sq;

  const phone = "355688188188";

  const handleWhatsApp = (service) => {
    const msg =
      lang === "en"
        ? `Hello, I am interested in: ${service.title.en}. Can you help me?`
        : `Përshëndetje, jam i interesuar për: ${service.title.sq}. A mund të më ndihmoni?`;

    window.open(
      `https://wa.me/${phone}?text=${encodeURIComponent(msg)}`,
      "_blank"
    );
  };

return (
  <main className="min-h-screen bg-slate-50 px-4 py-10 md:px-6 lg:py-14">
    <div className="mx-auto w-full max-w-[1500px]">
      {/* HEADER */}
      <div className="mx-auto mb-10 max-w-3xl text-center">
        <span className="mb-3  text-xs font-extrabold uppercase tracking-[0.18em] text-violet-600">
          MASTER SOL&amp;TECH
        </span>

        <h1 className="text-3xl font-black tracking-tight text-slate-950 md:text-4xl">
          {lang === "en"
            ? "Our Repair Services"
            : "Shërbimet tona të Riparimit"}
        </h1>

        <p className="mt-3 text-sm leading-6 text-slate-600 md:text-base">
          {lang === "en"
            ? "Professional repair solutions for phones, tablets, laptops and other devices."
            : "Zgjidhje profesionale për riparimin e telefonave, tabletëve, laptopëve dhe pajisjeve të tjera."}
        </p>
      </div>

      {/* SERVICES GRID */}
  {/* SERVICES GRID */}
<section
  className="
    grid
    grid-cols-1
    gap-5
    sm:grid-cols-2
    lg:grid-cols-4
  "
>
  {services.map((service) => (
    <article
      key={service.id}
      className="
        group
        relative
        flex
        min-h-[215px]
        flex-col
        overflow-hidden
        rounded-[20px]
        border
        border-slate-200
        bg-white
        p-5
        shadow-[0_8px_25px_rgba(15,23,42,0.06)]
        transition-all
        duration-300
        hover:-translate-y-2
        hover:border-violet-200
        hover:shadow-[0_16px_35px_rgba(79,70,229,0.12)]
      "
    >
      {/* Decorative Background */}
      <div
        className="
          absolute
          -right-8
          -top-8
          h-24
          w-24
          rounded-full
          bg-gradient-to-br
          from-violet-100
          to-blue-100
          opacity-70
          blur-2xl
          transition
          duration-300
          group-hover:scale-125
        "
      />

      {/* ICON */}
      <div
        className="
          relative
          z-10
          mb-4
          flex
          h-12
          w-12
          items-center
          justify-center
          rounded-xl
          bg-gradient-to-br
          from-violet-100
          to-blue-100
          text-2xl
          shadow-inner
          transition
          duration-300
          group-hover:rotate-6
          group-hover:scale-110
        "
      >
        {service.icon}
      </div>

      {/* TITLE */}
      <h3
        className="
          relative
          z-10
          text-base
          font-extrabold
          leading-6
          text-slate-900
        "
      >
        {lang === "en"
          ? service.title.en
          : service.title.sq}
      </h3>

      {/* DESCRIPTION */}
      <p
        className="
          relative
          z-10
          mt-2
          flex-1
          text-[13px]
          leading-6
          text-slate-600
        "
      >
        {lang === "en"
          ? service.description.en
          : service.description.sq}
      </p>

      {/* BUTTON */}
      <button
        type="button"
        onClick={() => handleWhatsApp(service)}
        className="
          mt-5
          flex
          h-11
          w-full
          items-center
          justify-center
          gap-2
          rounded-xl
          bg-green-600
          text-sm
          font-bold
          text-white
          transition
          hover:bg-green-700
          hover:-translate-y-0.5
        "
      >
        <i className="fab fa-whatsapp text-base"></i>

        {lang === "en"
          ? "Ask on WhatsApp"
          : "Pyet në WhatsApp"}
      </button>

      {/* Bottom Line */}
      <div
        className="
          absolute
          bottom-0
          left-0
          h-1
          w-0
          rounded-r-full
          bg-gradient-to-r
          from-violet-600
          to-blue-500
          transition-all
          duration-300
          group-hover:w-full
        "
      />
    </article>
  ))}
</section>

{/* CTA */}
<section
  className="
    relative
    mt-16
    overflow-hidden
    rounded-[28px]
    bg-gradient-to-r
    from-violet-600
    via-indigo-600
    to-blue-600
    px-6
    py-10
    text-center
    text-white
    shadow-[0_20px_50px_rgba(79,70,229,0.25)]
  "
>
  <div className="absolute -left-20 -top-20 h-52 w-52 rounded-full bg-white/10 blur-3xl" />
  <div className="absolute -right-20 -bottom-20 h-60 w-60 rounded-full bg-cyan-300/10 blur-3xl" />

  <div className="relative z-10 max-w-3xl mx-auto">
    <h2 className="text-3xl font-black">
      {text.ctaTitle}
    </h2>

    <p className="mt-4 text-white/90 leading-7">
      {text.ctaSub}
    </p>

    <button
      onClick={() => {
        const phone = "355688188188";

        const message =
          lang === "sq"
            ? `Përshëndetje,\n\nJam i interesuar për një nga shërbimet tuaja të riparimit.\nJu lutem më kontaktoni.\n\nFaleminderit!`
            : `Hello,\n\nI am interested in one of your repair services.\nPlease contact me.\n\nThank you!`;

        window.open(
          `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
          "_blank"
        );
      }}
      className="
        mt-8
        inline-flex
        items-center
        gap-3
        rounded-xl
        bg-green-500
        px-8
        py-4
        font-bold
        text-white
        transition
        hover:-translate-y-1
        hover:bg-green-600
      "
    >
      <i className="fab fa-whatsapp text-xl"></i>
      {text.contact}
    </button>
  </div>
</section>
    </div>
  </main>
);
};

export default Repair;